module.exports = __webpack_public_path__ + "Server-Unknown.None.5deef9a32e6384912ef1e612b5e4e613.hashedasset.svg";